import { render, staticRenderFns } from "./Converter.vue?vue&type=template&id=b5fb6130&scoped=true&"
import script from "./Converter.vue?vue&type=script&lang=js&"
export * from "./Converter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fb6130",
  null
  
)

export default component.exports